export default __webpack_public_path__ + "static/media/ys1.a876d79f.jpg";